<template>
  <v-container id="spot-inquiry" class="mt-2">
    <v-card flat color="transparent">
      <v-row dense>
        <v-col>
          <v-card-title class="font-weight-black py-0">{{
            $t("label.self_pick_spot")
          }}</v-card-title>
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row dense class="justify-center mt-8">
        <v-col cols="12" sm="12" md="4">
          <SelectZone
            v-model="Zone"
            :label="$t('label.zone')"
            class="flutter-zone"
          ></SelectZone>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <SelectCity
            v-model="City"
            :label="$t('label.city')"
            ref="city"
            :itemref="Zone.ZoneName"
          ></SelectCity>
        </v-col>
      </v-row>
    </v-card>

    <v-card flat color="transparent" min-height="300px">
      <v-container>
        <v-row>
          <v-col
            v-for="spot in Spots"
            :key="spot.CenterNo"
            :cols="12"
            sm="12"
            md="4"
            lg="3"
          >
            <v-card class="py-0" elevation="8">
              <v-card-title class="py-0 font-weight-bold"
                >{{ spot.Name }}
                <v-spacer></v-spacer>
                <v-btn icon text @click="showMapArea(spot)"
                  ><v-icon>{{ mdiMapMarker }}</v-icon></v-btn
                ></v-card-title
              >

              <v-card-text class="py-0 pre-formatted">{{
                spot.Address
              }}</v-card-text>
              <v-divider></v-divider>
              <v-card-text class="pre-formatted mb-0 pb-0"
                ><v-icon>{{ mdiClock }}</v-icon
                ><span class="font-weight-black">{{
                  $t("label.opening_hours")
                }}</span
                ><br />
                {{ spot.OpeningHours }}
              </v-card-text>
              <v-card-text class="pre-formatted"
                ><v-icon>{{ mdiAlert }}</v-icon
                ><span class="font-weight-black">{{
                  $t("label.cautions")
                }}</span
                ><br />
                {{ spot.Description }}</v-card-text
              >
              <v-divider></v-divider>
              <v-card-text class="font-weight-bold">{{
                spot.CityName
              }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="mapArea" eager width="820px" height="650px">
      <v-card>
        <v-row no-gutters>
          <v-col cols="10">
            <v-card-title>
              {{ mapTitle }}
            </v-card-title>
          </v-col>
          <v-col cols="2" class="my-auto">
            <v-btn
              color="primary"
              small
              icon
              @click="mapArea = false"
              class="float-right mx-6"
              ><v-icon>{{ mdiCloseThick }}</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters>
          <v-col>
            <OsmMap :mapMarker="mapMarker" :mapZoom="mapZoom"></OsmMap>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </v-container>
</template>

<script>
import { mdiMapMarker, mdiClock, mdiAlert, mdiCloseThick } from "@mdi/js";
import SelectZone from "@/components/Select/SelectZone.vue";
import SelectCity from "@/components/Select/SelectCity.vue";
import { GetSelfPickupSpot } from "@/api/publicServices";
import OsmMap from "@/components/OsmMap.vue";

export default {
  name: "SpotInquiry",
  components: {
    SelectZone: SelectZone,
    SelectCity: SelectCity,
    OsmMap: OsmMap,
  },
  data: () => ({
    message: "",
    Zone: {
      ZoneName: "",
    },
    City: [],
    Spots: [],

    page: 1,
    pageSize: 6,
    colSize: 3,
    mapArea: false,
    mapZoom: 18,
    mapMarker: { lat: 0, lng: 0 },
    mapTitle: "",
    //mapSize:{width:"820px",height:"650px"},

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiMapMarker,
    mdiClock,
    mdiAlert,
    mdiCloseThick,
  }),
  methods: {
    async GetSelfPickupSpot() {
      try {
        let CityCode = [];
        console.log(this.City);
        if (Array.isArray(this.City)) {
          for (let index in this.City) {
            CityCode.push(this.City[index].CityCode);
          }
        } else if (this.City !== null) {
          CityCode.push(this.City.CityCode);
        }

        const response = await GetSelfPickupSpot({
          ZoneName: this.Zone.ZoneName,
          CityCode: CityCode,
        });
        this.Spots = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getLength() {
      return Math.ceil(this.Spots.length / this.pageSize);
    },
    showMapArea(spot) {
      console.log(spot);
      this.mapZoom = 18;
      let lat = spot.Latitude;
      let lng = spot.Longitude;
      let title = `青蛙集運-${spot.Name}`;
      let type = "1";
      this.mapTitle = spot.Name;

      if (lat == 0 && lng == 0) {
        this.snackBarMsg.text = "Invalid GPS location";
        this.snackBarMsg.color = "red";
        this.snackBarMsg.show = true;
        return;
      }

      Object.assign(this.mapMarker, { lat, lng });
      if (localStorage.getItem("flutter") == "true") {
        try {
          window.flutter_inappwebview.callHandler("flutterMapHandler", {
            lat,
            lng,
            title,
            type,
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        this.mapArea = true;
      }
    },
  },
  watch: {
    Zone() {
      // if (this.$refs.city) {
      //   this.$refs.city.reset();
      // }
      this.GetSelfPickupSpot();
    },
    City() {
      this.GetSelfPickupSpot();
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre-line;
}
</style>
